// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Address, type AddressWireFormat, NewAddress } from '../Address/Address';
import {
  type IntegrationSummary,
  type IntegrationSummaryWireFormat,
  NewIntegrationSummary,
} from '../IntegrationSummary/IntegrationSummary';

export class DispatchCustomer {
  readonly id: string;
  readonly name: string;
  readonly code: string;
  readonly address: Address | null;
  readonly creditStatusCode: string | null;
  readonly creditStatusDescription: string | null;
  readonly companyId: string | null;
  readonly inactive: boolean;
  readonly externalId: string;
  readonly integrationSummary: IntegrationSummary | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.code = data.code === undefined ? '' : data.code;
    this.address =
      // eslint-disable-next-line no-nested-ternary
      (data.address ?? null) === null ? null : NewAddress(data.address);
    this.creditStatusCode = data.creditStatusCode === undefined ? null : data.creditStatusCode;
    this.creditStatusDescription =
      data.creditStatusDescription === undefined ? null : data.creditStatusDescription;
    this.companyId = data.companyId === undefined ? null : data.companyId;
    this.inactive = data.inactive === undefined ? false : data.inactive;
    this.externalId = data.externalId === undefined ? '' : data.externalId;
    this.integrationSummary =
      // eslint-disable-next-line no-nested-ternary
      (data.integration ?? data.integrationSummary ?? null) === null
        ? null
        : NewIntegrationSummary(data.integration ?? data.integrationSummary);
  }

  static zero(): DispatchCustomer {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomer> = {
      id: NIL_UUID,
      name: '',
      code: '',
      address: null,
      creditStatusCode: null,
      creditStatusDescription: null,
      companyId: null,
      inactive: false,
      externalId: '',
      integrationSummary: null,
    };
    return new DispatchCustomer(zeroValues);
  }

  toJSON(): { [key: string]: any } {
    return {
      id: this.id,
      name: this.name,
      code: this.code,
      address: this.address,
      creditStatusCode: this.creditStatusCode,
      creditStatusDescription: this.creditStatusDescription,
      companyId: this.companyId,
      inactive: this.inactive,
      externalId: this.externalId,
      integration: this.integrationSummary,
    };
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerWireFormat = {
  id: string;
  name: string;
  code: string;
  address: AddressWireFormat | null;
  creditStatusCode: string | null;
  creditStatusDescription: string | null;
  companyId: string | null;
  inactive: boolean;
  externalId: string;
  integrationSummary: IntegrationSummaryWireFormat | null;
};

type NewDispatchCustomerProps = PartialDeep<DispatchCustomer, { recurseIntoArrays: true }>;
export const NewDispatchCustomer: (props: NewDispatchCustomerProps) => DispatchCustomer = (props) =>
  new DispatchCustomer(props);

type NewDispatchCustomerFromWireFormatProps = PartialDeep<
  DispatchCustomerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerFromWireFormat: (
  props: NewDispatchCustomerFromWireFormatProps,
) => DispatchCustomer = (props) => new DispatchCustomer(props);
